module.exports = __webpack_public_path__ + "img/long-term-savings-insurance.cf80b6e.png";